import { createApp } from 'vue';

function vueApp(vueEl, data) {
    if (!vueEl) return;
    let props = typeof data === 'object' ? data : {}

    const app = createApp(props);
    if(props.components != undefined && typeof props.components === 'object'){
        for (const [key, value] of Object.entries(props.components)) {
            app.component(value.name, value);
        }
    }
    app.mount(vueEl);
}

export default function loadVue(vueEl, data) {
    if (NodeList.prototype.isPrototypeOf(vueEl)) {
        Array.prototype.forEach.call(vueEl, el => vueApp(el, data));
    } else {
        vueApp(vueEl, data);
    }
}
